/**
 * Quanto o card de preço mostra que a pessoa ganha (caça a bugs 26/09, item 12).
 *
 * O número é SEMPRE do servidor: com o card escolhido, a prévia (`/api/venda/previa` — o mesmo
 * motor do registro, com o arredondamento e o teto); antes de escolher, o valor que o servidor
 * mandou junto do produto (calculado pela mesma prévia). A tela nunca faz a conta sozinha — cortar
 * o prêmio em 2 casas ou esquecer o teto fazia o card dizer um valor e a prévia outro.
 */
export function ganhoDoCartao(
  chave: string,
  escolha: string | null,
  previa: { readonly premioUnitario: string; readonly bloqueio: string | null } | null,
  doServidor: string | null,
): string | null {
  if (escolha === chave && previa && !previa.bloqueio) return previa.premioUnitario;
  return doServidor;
}
